import { get } from 'lodash';
import {
  crfsCountPercentTranform,
  modifiedChartsAndSideCardData,
} from '../../../__utility__/crfsCountPercentTransform';
import { CHART_TYPES } from '../../../utility/constant';

function crfFrozenTransform(data) {
  const countYAxisLabel = 'CRFs frozen';
  const percentYAxisLabel = '% CRFs frozen';
  const countChartDataKey = 'count';
  const percentChartDataKey = 'percentage';
  const countGroupColKey = 'count';
  const percentGroupColKey = 'percent';
  const chartType = get(data, 'isBarChartStatusVisible')
    ? CHART_TYPES.LOW_HIGH
    : CHART_TYPES.SITES;

  const modifiedData = modifiedChartsAndSideCardData(
    data,
    chartType,
    countChartDataKey,
    percentChartDataKey,
  );

  return crfsCountPercentTranform(
    modifiedData,
    countYAxisLabel,
    percentYAxisLabel,
    countGroupColKey,
    percentGroupColKey,
  );
}

export default crfFrozenTransform;
